import { render } from "./JourneySets.vue?vue&type=template&id=b4a55198&scoped=true"
import script from "./JourneySets.vue?vue&type=script&lang=ts"
export * from "./JourneySets.vue?vue&type=script&lang=ts"

import "./JourneySets.vue?vue&type=style&index=0&id=b4a55198&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4a55198"

export default script